import { memo, PropsWithChildren } from "react";

import { Text, Grid, Pagination, Space, Card, Sx } from "@mantine/core";

/* eslint-disable  @typescript-eslint/no-explicit-any */
type CustomPaginationProps = {
  activePage: number;
  maxLength: number;
  setPage: any;
  setLowerBound: any;
  setUpperBound: any;
  itemsPerPage?: number;
  containerStyle?: Sx;
};

const CustomPagination = ({
  activePage,
  setPage,
  setLowerBound,
  setUpperBound,
  maxLength,
  itemsPerPage = 20,
}: CustomPaginationProps) => {
  const numPages = Math.ceil(maxLength / itemsPerPage);

  const lowerBound = (activePage - 1) * itemsPerPage + 1;
  const upperBound = Math.min(maxLength, activePage * itemsPerPage);

  const paginationText =
    `Showing ` +
    (lowerBound === upperBound
      ? `${lowerBound} of ${maxLength}`
      : `${lowerBound}-${upperBound} of ${maxLength}`);

  setLowerBound(lowerBound);
  setUpperBound(upperBound);

  if (numPages <= 1) return <></>;

  return (
    <Grid justify="space-between">
      <Grid.Col span="auto">
        <Text size="sm">{paginationText}</Text>
      </Grid.Col>
      <Grid.Col span="content">
        <Pagination
          page={activePage}
          onChange={setPage}
          total={numPages}
          withControls={false}
        />
      </Grid.Col>
    </Grid>
  );
};

const CustomPaginationWrapper = ({
  activePage,
  setPage,
  setLowerBound,
  setUpperBound,
  maxLength,
  itemsPerPage = 20,
  children,
  containerStyle,
}: PropsWithChildren<CustomPaginationProps>) => {
  return (
    <>
      <Card withBorder py={0} px={16} sx={containerStyle}>
        {children}
      </Card>
      <Space h="md" />
      <CustomPagination
        activePage={activePage}
        setPage={setPage}
        setLowerBound={setLowerBound}
        setUpperBound={setUpperBound}
        maxLength={maxLength}
        itemsPerPage={itemsPerPage}
      />
    </>
  );
};

export default memo(CustomPaginationWrapper);
